import IconChevronLeft from '@/assets/svgs/chevron-left.svg?react'
import IconChevronRight from '@/assets/svgs/chevron-right.svg?react'
import PropTypes from 'prop-types'

const Pagination = ({
  totalItems,
  pageLimit,
  currentPage,
  totalPages,
  onPageChange,
  getPageLabel,
}) => {
  const renderPaginationInput = () => {
    return (
      <input
        type="number"
        min="1"
        max={totalPages}
        value={currentPage}
        onChange={e => {
          const page = parseInt(e.target.value)
          if (page >= 1 && page <= totalPages && onPageChange) {
            onPageChange(page)
          }
        }}
        className="max-w-8 mr-2 p-2 type-body-2 text-grey-10 text-center border border-grey-80 [&::-webkit-outer-spin-button]:m-0 [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:m-0 [&::-webkit-inner-spin-button]:appearance-none"
      />
    )
  }

  const goToPrevPage = () => {
    if (currentPage > 1 && onPageChange) {
      onPageChange(currentPage - 1)
    }
  }

  const goToNextPage = () => {
    if (currentPage < totalPages && onPageChange) {
      onPageChange(currentPage + 1)
    }
  }

  return (
    <div>
      <div className="flex items-center">
        <div className="flex flex-col sm:flex-row sm:items-center px-4 py-2 sm:py-4 text-xs leading-6 w-full gap-2 sm:gap-0">
          <div className="hidden sm:block type-body-1 text-grey-50 sm:mr-2">
            Showing {getPageLabel(totalItems, pageLimit, currentPage - 1)} of {totalItems || 0}{' '}
            entries
          </div>
          {/* Mobile nav */}
          <div className="flex sm:hidden items-center justify-center gap-4">
            <button
              data-testid="pagination-prev"
              className="flex items-center min-w-0 h-7 p-0 border-0 bg-transparent"
              onClick={goToPrevPage}
              disabled={currentPage <= 1}
            >
              <IconChevronLeft />
            </button>
            <span className="text-sm font-medium text-grey-50">
              Page {currentPage} of {totalPages || 1}
            </span>
            <button
              data-testid="pagination-next"
              className="flex items-center min-w-0 h-7 p-0 border-0 bg-transparent"
              onClick={goToNextPage}
              disabled={currentPage >= totalPages}
            >
              <IconChevronRight />
            </button>
          </div>

          {/* Desktop nav */}
          <div className="hidden sm:flex sm:ml-auto items-center">
            {renderPaginationInput()}
            <span className="mr-4 text-sm font-medium text-grey-50">
              {' '}
              of {totalPages || 1} pages{' '}
            </span>
            <button
              data-testid="pagination-prev"
              className="flex items-center min-w-0 h-7 p-0 border-0 bg-transparent"
              onClick={goToPrevPage}
              disabled={currentPage <= 1}
            >
              <IconChevronLeft />
            </button>
            <button
              data-testid="pagination-next"
              className="flex items-center min-w-0 h-7 p-0 border-0 bg-transparent ml-2"
              onClick={goToNextPage}
              disabled={currentPage >= totalPages}
            >
              <IconChevronRight />
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

Pagination.propTypes = {
  totalItems: PropTypes.number.isRequired,
  pageLimit: PropTypes.number.isRequired,
  currentPage: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  getPageLabel: PropTypes.func.isRequired,
}

export default Pagination
